import moment from "moment";

export const DATE_DISPLAY_FORMAT = "DD/MM/YYYY";

export function formatDisplayDate(dateLike) {
  if (!dateLike) return "";
  const m = moment(dateLike);
  if (!m.isValid()) return "";
  return m.format(DATE_DISPLAY_FORMAT);
}

export function parseDisplayDate(ddmmyyyy) {
  // Accept dd/mm/yyyy strictly
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(ddmmyyyy)) return null;
  const [day, month, year] = ddmmyyyy.split("/").map((p) => parseInt(p, 10));
  const d = new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
  return isNaN(d.getTime()) ? null : d;
}
